import { RootState } from "../../core/rootReducers";

export const selectTradersLoading = (state: RootState) => {
	return state.pricingTraders.loader.traders;
};

export const selectTraders = (state: RootState) => {
	return state.pricingTraders.traders;
};
